import AIPluginController from './AIPluginController';

const AiPluginController = new AIPluginController();

export {
  AiPluginController
}